export const flattenCategories = (categories) => {
    let result = [];
    
    const flatten = (items) => {
      items.forEach(item => {
        result.push({
          id: item.id,
          name: item.name
        });
        
        if (item.children && item.children.length > 0) {
          flatten(item.children);
        }
      });
    };
    
    flatten(categories);
    return result;
  };
